import styled from 'styled-components/macro';
import { space, typography, color, layout, position } from 'styled-system';

// Swap font-family for sans-serif in default theme
export const Text = styled.p`
  font-family: ${(props) =>
    props.bold ? props.theme.fontTextBold : props.theme.fontText};
  text-decoration: ${(props) => (props.underline ? 'underline' : undefined)};
  font-size: 1.4rem;
  line-height: normal;
  color: ${(props) => props.theme.textColor};
  font-variant-numeric: ${(props) => (props.monospaced ? 'tabular-nums' : 'normal')};
  white-space: ${(props) =>
    props.renderWhiteSpace ? 'pre-wrap' : props.nowrap ? 'nowrap' : 'normal'};
  pointer-events: ${(props) => (props.pointerNone ? 'none' : undefined)};
  text-transform: ${(props) => (props.capitalize ? 'capitalize' : undefined)};
  ${space}
  ${typography}
  ${color}
  ${position}

  a {
    color: ${(props) => props.theme.textColor};
    text-decoration: underline;
  }

  ul,
  ol {
    white-space: initial;
    list-style: disc;
  }

  li {
    list-style-position: outside;
    margin-left: 16px;

    a {
      text-decoration: underline;
    }
  }

  li:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const Ol = styled.ol`
  ${space}
`;
export const Ul = styled.ul`
  ${space}
`;

export const Li = styled.li`
  list-style-position: outside;
  margin-left: 16px;
  font-family: ${(props) =>
    props.bold ? props.theme.fontTextBold : props.theme.fontText};
  text-decoration: ${(props) => (props.underline ? 'underline' : undefined)};
  font-size: 1.4rem;
  line-height: normal;
  color: ${(props) => props.theme.textColor};
  font-variant-numeric: ${(props) => (props.monospaced ? 'tabular-nums' : 'normal')};
  white-space: ${(props) => (props.renderWhiteSpace ? 'pre-wrap' : 'normal')};
  ${space}
  ${typography}
  ${color}
`;

export const Link = styled.a`
  font-family: ${(props) => props.theme.fontLink};
  font-size: 1.4rem;
  font-weight: normal;
  line-height: normal;
  color: ${(props) => props.theme.textColor};
  transition: all 0.2s;
  ${space}
  ${typography}
  ${color}

  :hover {
    background-color: rgb(46, 61, 92, 0.08);
  }
`;

export const Label = styled.label`
  font-family: ${(props) =>
    props.bold ? props.theme.fontTextBold : props.theme.fontLabel};
  font-size: 1.4rem;
  font-weight: normal;
  line-height: normal;
  color: ${(props) => (props.error ? props.theme.errorColor : props.theme.textColor)};
  font-variant-numeric: ${(props) => (props.monospaced ? 'tabular-nums' : 'normal')};
  white-space: ${(props) => (props.renderWhiteSpace ? 'pre-wrap' : 'normal')};
  ${space}
  ${typography}
  ${color}
  ${layout}

  &.focus-visible {
    outline: none;
    box-shadow: 0px 0px 0px 2px
      ${(props) =>
        props.selected
          ? props.theme.highLightColor
          : props.disabled
          ? props.theme.subTextColor
          : props.theme.textColor};
  }
`;

export const Warning = styled(Label)`
  color: #ffcc00;
`;

export const BigLabel = styled(Label)`
  font-size: 1.6rem;
`;

export const SubLabel = styled(Label)`
  font-family: ${(props) => props.theme.fontSubLabel};
  font-size: 1.2rem;
  color: ${(props) => props.theme.subTextColor};
`;

export const CapsLabel = styled(SubLabel)`
  font-size: 1.4rem;
  font-variant: all-small-caps;
`;

export const Heading = styled.h1`
  font-family: ${(props) => props.theme.fontHeading};
  font-size: 2rem;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 1.11px;
  text-transform: ${(props) => (props.theme.name === 'starboard' ? 'none' : 'uppercase')};
  color: ${(props) =>
    props.highLight ? props.theme.highLightColor : props.theme.textColor};
  ${space}
  ${typography}
  ${color}
`;

export const Heading2 = styled.h2`
  font-family: ${(props) => props.theme.fontHeading2};
  font-size: 1.6rem;
  font-weight: normal;
  line-height: normal;
  color: ${(props) => props.theme.textColor};
  pointer-events: ${(props) => (props.pointerNone ? 'none' : undefined)};
  ${space}
  ${typography}
  ${color}
`;
